export function emptyAboutDetail(lang) {
  return { lang, image: '', video: '' };
}

export function mergeAboutDetailsWithLanguages(languages, existingDetails = []) {
  const langEntries = [];
  const seen = new Set();

  (languages || []).forEach((lang) => {
    const code = lang.code || lang;
    if (!code || seen.has(code)) {
      return;
    }
    seen.add(code);
    langEntries.push({ code, label: lang.label || code });
  });

  (existingDetails || []).forEach((item) => {
    if (!item?.lang || seen.has(item.lang)) {
      return;
    }
    seen.add(item.lang);
    langEntries.push({ code: item.lang, label: item.lang });
  });

  const map = new Map((existingDetails || []).map((item) => [item.lang, { ...item }]));
  return langEntries.map(({ code, label }) => {
    const found = map.get(code);
    return found
      ? { ...found, lang: code, _label: label }
      : { ...emptyAboutDetail(code), _label: label };
  });
}

export function stripAboutDetails(details) {
  return (details || []).map(({ lang, image, video }) => ({
    lang,
    image: image || '',
    video: video || '',
  }));
}

export function hasAboutContent(detail) {
  return Boolean(detail?.image?.trim() || detail?.video?.trim());
}
